import SeoLandingLayout from './components/SeoLandingLayout';

export default function NutricionistaClinicoPalmaPage() {
  return (
    <SeoLandingLayout
      title="Nutricionista Clinico en Palma de Mallorca | Dario Rojas"
      description="Nutricionista clinico en Palma de Mallorca para mejorar salud metabolica, digestiva y control de peso con enfoque personalizado."
      canonicalPath="/nutricionista-clinico-palma-de-mallorca"
      heading="Nutricionista clinico en Palma de Mallorca"
      intro="Si necesitas un enfoque clinico y personalizado, te acompaño en el tratamiento nutricional orientado a salud digestiva, metabolismo y composicion corporal."
      bullets={[
        'Evaluacion nutricional completa y objetivos medibles',
        'Intervencion personalizada segun historial y sintomas',
        'Plan progresivo con seguimiento profesional',
        'Coordinacion de habitos para resultados sostenibles',
      ]}
      sections={[
        {
          title: 'Enfoque clinico y seguimiento profesional',
          paragraphs: [
            'Cuando hay objetivos de salud concretos, es importante un enfoque clinico estructurado. Evaluamos sintomas, antecedentes y respuesta al plan para tomar mejores decisiones nutricionales.',
            'El seguimiento permite ajustar el tratamiento y mejorar adherencia para que los resultados sean estables y sostenibles.',
          ],
        },
      ]}
      faqItems={[
        {
          question: 'Para que casos se recomienda nutricion clinica?',
          answer:
            'Es recomendable cuando hay objetivos de salud digestiva, metabolica o control de peso con acompanamiento profesional.',
        },
        {
          question: 'Se adapta el plan si tengo medicacion o antecedentes medicos?',
          answer:
            'Si, el plan se personaliza segun historial clinico y necesidades individuales.',
        },
      ]}
      schema={{
        '@context': 'https://schema.org',
        '@type': 'MedicalBusiness',
        name: 'Dario Rojas Nutricion',
        url: 'https://dariorojasnutricion.es/nutricionista-clinico-palma-de-mallorca',
        medicalSpecialty: 'Nutrition',
        areaServed: 'Palma de Mallorca',
        telephone: '+34 685546738',
        email: 'dariorojasnutricion@gmail.com',
      }}
    />
  );
}
